<template>
    <!-- Tarjeta de la Billetera -->
    <div class="section wallet-card-section pt-1">
        <div class="wallet-card">
            <!-- Balance -->
            <div class="balance">
                <div class="left">
                    <!-- <span class="title">Saldo Total</span>
                    <h1 class="total">$ {{ $root.total.amount }}</h1> -->
                    <span class="title">{{ userData.username }}</span>
                    <h1 class="total">ASW-{{ userData.id }}</h1>
                </div>
                <div class="right">
                    <!-- <a href="#" class="button" data-bs-toggle="modal" data-bs-target="#depositActionSheet">
                        <ion-icon name="add-outline"></ion-icon>
                    </a> -->
                </div>
            </div>
            <!-- * Balance -->
            <!-- Pie de Página de la Billetera -->
            <div class="wallet-footer">
                <div class="item">
                    <a href="#" data-bs-toggle="modal" data-bs-target="#withdrawActionSheet">
                        <div class="icon-wrapper bg-danger">
                            <ion-icon name="arrow-down-outline"></ion-icon>
                        </div>
                        <strong>Retirar</strong>
                    </a>
                </div>
                <div class="item">
                    <a href="#" data-bs-toggle="modal" data-bs-target="#sendActionSheet">
                        <div class="icon-wrapper">
                            <ion-icon name="arrow-forward-outline"></ion-icon>
                        </div>
                        <strong>Transferir</strong>
                    </a>
                </div>
                <div class="item">
                    <a href="#" data-bs-toggle="modal" data-bs-target="#depositActionSheet">
                        <div class="icon-wrapper bg-success">
                            <ion-icon name="add-outline"></ion-icon>
                        </div>
                        <strong>Depositar</strong>
                    </a>
                </div>
                <div class="item">
                    <a href="#" data-bs-toggle="modal" data-bs-target="#blockingActionSheet">
                        <div class="icon-wrapper bg-info">
                          <ion-icon name="cash-outline"></ion-icon>
                        </div>
                        <strong>Liquidez</strong>
                    </a>
                </div>
                <!-- <div class="item">
                    <a href="app-cards.php">
                        <div class="icon-wrapper bg-success">
                            <ion-icon name="card-outline"></ion-icon>
                        </div>
                        <strong>Tarjetas</strong>
                    </a>
                </div> -->
                <!-- <div class="item">
                    <a href="#" data-bs-toggle="modal" data-bs-target="#exchangeActionSheet">
                        <div class="icon-wrapper bg-warning">
                            <ion-icon name="swap-vertical"></ion-icon>
                        </div>
                        <strong>Intercambiar</strong>
                    </a>
                </div> -->
                <!-- <div class="item">
                    <a href="#" data-bs-toggle="modal" data-bs-target="#sellActionSheet">
                        <div class="icon-wrapper bg-success">
                          <ion-icon name="cash-outline"></ion-icon>
                        </div>
                        <strong>Vender</strong>
                    </a>
                </div> -->

            </div>
            <!-- * Pie de Página de la Billetera -->
        </div>
    </div>
    <!-- Tarjeta de la Billetera -->

    <!-- Hoja de Acción de Retiro -->
    <div class="modal fade action-sheet- modalbox" id="withdrawActionSheet" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Retirar Dinero</h5>
                    <a href="#" data-bs-dismiss="modal">Cerrar</a>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <form-withdraw-balance />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Hoja de Acción de Retiro -->

    <!-- Hoja de Acción de Envío -->
    <!-- <div class="modal fade action-sheet" id="blockingActionSheet" tabindex="-1" role="dialog"> -->
    <div class="modal fade modalbox" id="blockingActionSheet" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Bloquear activos</h5>
                    <a href="#" data-bs-dismiss="modal">Cerrar</a>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <form-blocking-balance />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Hoja de Acción de Envío -->

    <!-- Hoja de Acción de Envío -->
    <div class="modal fade action-sheet- modalbox" id="sellActionSheet" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Vender</h5>
                    <a href="#" data-bs-dismiss="modal">Cerrar</a>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <form-sell-balance />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Hoja de Acción de Envío -->

    <!-- Hoja de Acción de Envío -->
    <div class="modal fade action-sheet- modalbox" id="sendActionSheet" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Enviar Dinero</h5>
                    <a href="#" data-bs-dismiss="modal">Cerrar</a>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <form-send-balance />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Hoja de Acción de Envío -->

    <!-- Hoja de Acción de Intercambio -->
    <!-- <div class="modal fade action-sheet" id="exchangeActionSheet" tabindex="-1" role="dialog"> -->
    <div class="modal fade action-sheet- modalbox" id="exchangeActionSheet" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Intercambiar Dinero</h5>
                    <a href="#" data-bs-dismiss="modal">Cerrar</a>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <form-exchange-balance />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Hoja de Acción de Intercambio -->
     
    <!-- Hoja de Acción de Depósito -->
    <div v-if="!isLoading" class="modal fade action-sheet- modalbox" id="depositActionSheet" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header text-center">
                    <h5 class="modal-title">Agregar Saldo</h5>
                    <a href="#" data-bs-dismiss="modal">Cerrar</a>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <form-add-balance />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- * Hoja de Acción de Depósito -->
</template>

<script>
import { mapState } from 'vuex';
export default {
    data() {
        return {
            balance: 0,
        }
    },
    computed: {
        ...mapState(['userData', 'isLoading']),
    }
}
</script>